import type React from 'react';
import { getUser } from '@/lib/auth';
import { useSurfaces } from '@/hooks/useSurfaces';
import { NoticeRedirect } from './RouteNotice';

export function RequireDirector({ children }: { children: React.ReactNode }) {
  const user = getUser();
  const { homePath, settled } = useSurfaces();
  const isServerConfirmedDirector =
    user?.isDirector === true && user.directorStatusSource === 'auth_me';

  if (!isServerConfirmedDirector) {
    // Resolve the caller's authoritative home before redirecting. This avoids the
    // former /command → /dashboard → /research chain for customers and gives the
    // route notice one final destination.
    if (!settled) {
      return (
        <div className="flex h-full min-h-[40vh] items-center justify-center text-sm text-gray-400">
          Checking access…
        </div>
      );
    }
    return <NoticeRedirect to={homePath} message="Director access required." />;
  }

  return <>{children}</>;
}
